const _version = "3.8.10"
function version() {
    return _version
}
export default version
